<template>
  <div class="ofdconverter-view">

    <!-- 软件落地页的子标题栏 -->
    <div class="soft-page-header-wrapper white-theme" id="soft-page-header">
      <div class="soft-page-header-content">
        <div class="soft-page-header-left">
          <div class="soft-page-header-left-gname">
            <img :src="szSoftIconUrl" alt="">
            <h1>{{szSoftName}}</h1>
          </div>
        </div>

        <div class="soft-page-header-right">
          <div class="soft-page-header-right-download">
            <a class="secondary-download-outer-btn" href="javascript:void(0)" @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
              <img src="/images/softs/iconWin.svg" alt="">
              <span>立即下载</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="soft-page-content-wrapper">
      <!-- 软件简介、软件下载页面 -->
      <div id="soft-introduction">
        <div>
          <!-- 软件名 -->
          <div id="soft-name">
            <span>{{szSoftName}}</span>
          </div>
          <!-- 文字简介 -->
          <div id="soft-introduction-text">
            <p>功能强大的OFD批量处理工具</p>
            <p>支持OFD与PDF、Word、图片等多种文件格式互转，一键解决OFD格式处理、阅读、转换操作</p>
          </div>
          <!-- 下载按钮 -->
          <div>
            <el-button type="primary" id="btn-soft-download"
              @click.left="Util.DownloadButtonClicked(szSoftPackageUrl)">
              <img alt="系统标识" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAMAAABg3Am1AAAAkFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+WABnwAAAAL3RSTlMABBXkys4QpOHVt66DJAz89fDgsp9rLOqnkVtSPTMfG9nRvph8dEcSCMWKWEsJBgLl7SIAAADgSURBVEjH7ZbJDoIwEECngFUKVAVEZV/dlf//O0U4UdIC0UQT3nEy79JD38BXeUBfEJWcq77TjiDkJBn+Zm8l6/KFLAEHGjm3IiPqqnzDE7ARAmjKolnlCZJz2OxJItsA1QJHQFHgFfY53i7LijlXQJ6uqfK6Xi17CNhszYXCYhIm4TMCJbM2OsCsA4KhBrVpZux4nEAtpY0OoHRg4V991kn4V8EcKCD3Yg357msp9N18p5hsUMTJylJ1yyRLFEWjiqLJjSILDQMvt9OYyW6fsBOVCTsfhKPAZU4HMXcYwRNYaeZo5GjN5QAAAABJRU5ErkJggg=="/>
              <span>免费下载</span>
            </el-button>
          </div>
          <!-- 支持的操作系统 -->
          <div id="soft-supported-sys">
            <span>适用系统：Win8/Win10/Win11</span>
          </div>
        </div>

        <!-- 软件图片 -->
        <div id="soft-introduction-image">
          
        </div>
      </div>

      <!-- 软件操作步骤介绍 -->
      <div id="soft-operation-steps">
        <div class="title">
          只需三步即可完成OFD格式转换
        </div>
        <div class="box-item">
          <div class="step-item">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAABsCAMAAADezpntAAAA5FBMVEUAAAD/0zL/0zH/0y//0zH/0zH/1TD/0zH/0zH/1DH/0y2ThOj/0zH/0i//2C+1q+//0zH/0zH/0jH/0zD/0zD/wCWThej/0zKThOeTheiThej/0zH/0jH/1DD/0y6SgOqRf+r/0jK1q++zqu7/0zG1qu6xqvH/zim1q++Thej/////0zJ0Yt//+eX/+OB8a+F+beHKw/PGv/L1zUr90TfAsdL//vvXvZbt6vubjul+buG9r9v/7rHewYTiw3zuyV64rebDs8n/77X/7a3mxXHqyGXzzFH60Dzk4fn/7rLcwIn70Dyy0faDAAAAKHRSTlMA+/Ukw5gv4dzYE+m7KBnvsKaOin8G8/HBs6iegnU3JB3Ts7NuLSQfbB7xeAAAAjlJREFUeNrt2GtT2kAUgOGTG0RARAHrrWrvmyxVaoJAUdS2alv///9RRyeSVbI7mUzOQc/7jW/P7LJndwJEqnRarm/bvtvqVIBgTtuXM/ltB2jV9CypZHlNINSOLV/I3gEq1RpyTo0akKhSlXOrkjg3u7bMyN4F9JpVmVkVfa+7blp0Ev5WjG4XcPMU0EF4IJU8QM2x9ETLAcxWpZ4otwGxZWlCtJYh3ddPK6KsTo2Icg1SfVkR5RWZEZcg1UdRXgNpRpTpnS5zEYemxPcpoiixP6bEVTTimSnRRSNGpsQlNGL8APj1/anj8Hjm179H4js04s0DIJwfOjHSreIJ+kYbH5cGD51SRvc4KKZx7gtQSwyKKvczAoto/hhDJA5iE6LlIBLF1IToASZxEuuJdhOVKIZ6YgdyEP+GhTQSd13qiA3IQwwLStx1HmV/jfBr6ERxEcuM7ArgE8VFlPnxjgJRTM7mCd0a0CCK89MXN9ta6wIVohCTafwMuP0NgBBRiMH/q9TLoe0AECPeK4fTy6vr6w8t77Pqy088+tnL6vCHCVENkoogHvay6+MTe7rwiQuwikd98v9FbUxkohmx+NGtOT0Eh45Sn+LoVmLigm70zO1C9bgswNBh4hsh8u3Co5vKKvLoZiITmchEqsQxfaIaE5nIxNdEHBUjHOUlosdEJjKRiVkxkYkFEjcCom0kxIBsTGQilZjIRCotErEeEK2eELcCom0lxP31gGTr+5C0t0lwr+ubewnwFlmFgxHG6MNlAAAAAElFTkSuQmCC"/>
            <p class="step-item-title">添加OFD文件</p>
            <p class="step-item-text">使用添加图标选项或直接拖放功能添加OFD文件</p>
          </div>

          <div class="step-item-connector">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAAAtCAMAAACd+6kiAAAAgVBMVEUAAACSkpKPj4+Pj4+Pj4+Ojo6WlpaPj4+Pj4+Pj4+QkJCPj4+Pj4+Pj4+Pj4+Pj4+Pj4+QkJCQkJCPj4+SkpKPj4+Pj4+Pj4+Pj4+Pj4+QkJCPj4+RkZGPj4+Pj4+Pj4+Pj4+Ojo6Ojo6Ojo6Pj4+Pj4+QkJCPj4+QkJCPj4+Pj4/wjECIAAAAKnRSTlMAEwii9ykE/Ox7G4NtZmFcSTI4Iw2yqY5y308+GObW0cuWk1RC8Libi8D2p2XtAAACAklEQVRYw+3Y2W7qQBAE0PKGN4xXbEzMvqb+/wOvSZ4i3cxij60oynkZCUvQjLpLDfgjtbIwRp5sNml/Wt4CpsT0MIiXnrL+aEg6/RnSXW9hgu2QxcDvQj77M3UeH7WFLbmBAdY7ySv0VNkFQLa7x/nXN0vK1+sWxnHY07txK3a5x7dKP3jDOFff50qvJp+H+Pt2jo70tyOHjsdTClVvNoClZCbO/hKjHDVuqTiqNXGOUQoGNhSFZBBiBqn6PXdBo1y/9YbJ5XoZHbmuhWlVtW4arvkcmpglVHgB3VjzXunaGKRhqFS6u4+gqW6G1RTR99TuE7M5sZbn/Aqzuu4iiC1i0sPPcqcfDp0f54BJLP3h2ecygq4S01pTuxWfdCTd1mGUDWvo8WQr74U7G2N0+QJ69nyIO4lsMLOslS3FIWa3kDzO8RtVh53OmIpzIHZgREv1dDuLRyokM5hwZgxFCVmIHyeG5ogHKHqIAzYKlqbGqBQmnM5IVfizrSFitRcY5RWQWbnC/rUPfIdJF/8oX4fYiNeL1oJJi1a6sHS3RJwStxJmpQwqWdzP/gPFEUR5tA7xs9jnm+wSbcfCRDLvv70WsI5kC9Md0ygD9/z1w7vNq8ptIW3Gm4dpWCdy35+V/bm1pXvFHbZmgsnkTvi5TtN51aT8R/oFU1u6/OiPrrCh4h8VayGEJmdFogAAAABJRU5ErkJggg=="/>
          </div>

          <div class="step-item">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIMAAABtCAMAAAC1DSKmAAAAwFBMVEUAAAC1q++1q++Th+eYieH/2VP/2lOThemTheeThej/2lKThej/2lOSheiroOy1pty/sdi7ruDbvoffwn+SheiRhOeRg+aRguv/2FOPh+f/11Gii/+1q++Thej/2lP///+tou3kxXjc1/j7+v64ru/u7Py9tfG6sfCekuv9/P+5r/D18/3BuPLRyvXEvPLx7/zW0fbTzfb39/3f2/jq5/vNx/TKwvTHv/Pj3vnZ1Pfn5PrMxfSsou7Px/Sxp++wpu5Zmof9AAAAHHRSTlMAzrBA7bCq/Pjp1p2V3NrYz8O/v7x2SDMuIBMLRI1o+QAAAohJREFUaN7t2elu00AUhuECha7sO9g94JV4zb4WuP+7ok4qj1OOO46OP9mK5v01qo7kx51R4iQnh/bt8qbdLr8cbLi+abvrgw0vWjc8P3nWtO84g920Dz0wnH3q3mBf9MBgX/XAcPa5e4N90QODfdUDw/lXqCHwx6tf21Xou85uFfnupFipXiINFt01LVZ/ipVfrG6LVW7v9RFocKiouOlhuRqVK9X5u59t976JAdzp3l6si9Xfclduy12Bdlo5k67Dn0lYytB5xmAMxmAM/Ta8+tF1r0+eWF33pgeGtz0wPDWGozQsfK/5MMYwJ4qjpsMYw4zuisNmwxhDStvGQZNhjGFE97mJfhhjGFHZINMNgwyRSyotArQXYRUx102DzmQwINVMNy036BEjzTDIYCVVxFAz3Kphpm45qyIcbhhjmFdveTHowpDtX26uISAMCW2blH/YPEaAGAK6b6mORz0BYgjV9q/Ve5eeIDfwr89T9dbBEyAGb0zVcq/cDm4aYvBi2i8uEUwQg5fTw8Zh3TDI4NP/uYHFhzFMicuN2GGMYUlsE3ZYbJATMAaH2Bx2GGNYSQlyw5DYVuwwxpCSSvvchDFspAS5YUEq7SMsxpARW8oOYwzJQEiQGwKXuH6zwwBDPWHDDmMM4Zi45uwwxhDFQoLcEOXEtWCHMQbPFxLkBm9KKt03LiDDmiUk/DDGsJQS5AaPmNwaAsgQiJ+h5YZETJAbFmKC3DAUf6KSG5ZigtyQ016xhgAxPCBElirKqSY/bNMQPvIRf0W1pW0aEvarjl0O1TZp05CV/4K1k3pWJ4YZUTx10kxdvoO9YK4uP5NH/PumMRiDMRiDMWwzhl3GsMsYdh2n4R/HQh0ysLxgKwAAAABJRU5ErkJggg=="/>
            <p class="step-item-title">编辑转换参数</p>
            <p class="step-item-text">在参数设置中选择所需的格式</p>
          </div>

          <div class="step-item-connector">
            <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJMAAAAtCAMAAACd+6kiAAAAgVBMVEUAAACSkpKPj4+Pj4+Pj4+Ojo6WlpaPj4+Pj4+Pj4+QkJCPj4+Pj4+Pj4+Pj4+Pj4+Pj4+QkJCQkJCPj4+SkpKPj4+Pj4+Pj4+Pj4+Pj4+QkJCPj4+RkZGPj4+Pj4+Pj4+Pj4+Ojo6Ojo6Ojo6Pj4+Pj4+QkJCPj4+QkJCPj4+Pj4/wjECIAAAAKnRSTlMAEwii9ykE/Ox7G4NtZmFcSTI4Iw2yqY5y308+GObW0cuWk1RC8Libi8D2p2XtAAACAklEQVRYw+3Y2W7qQBAE0PKGN4xXbEzMvqb+/wOvSZ4i3cxij60oynkZCUvQjLpLDfgjtbIwRp5sNml/Wt4CpsT0MIiXnrL+aEg6/RnSXW9hgu2QxcDvQj77M3UeH7WFLbmBAdY7ySv0VNkFQLa7x/nXN0vK1+sWxnHY07txK3a5x7dKP3jDOFff50qvJp+H+Pt2jo70tyOHjsdTClVvNoClZCbO/hKjHDVuqTiqNXGOUQoGNhSFZBBiBqn6PXdBo1y/9YbJ5XoZHbmuhWlVtW4arvkcmpglVHgB3VjzXunaGKRhqFS6u4+gqW6G1RTR99TuE7M5sZbn/Aqzuu4iiC1i0sPPcqcfDp0f54BJLP3h2ecygq4S01pTuxWfdCTd1mGUDWvo8WQr74U7G2N0+QJ69nyIO4lsMLOslS3FIWa3kDzO8RtVh53OmIpzIHZgREv1dDuLRyokM5hwZgxFCVmIHyeG5ogHKHqIAzYKlqbGqBQmnM5IVfizrSFitRcY5RWQWbnC/rUPfIdJF/8oX4fYiNeL1oJJi1a6sHS3RJwStxJmpQwqWdzP/gPFEUR5tA7xs9jnm+wSbcfCRDLvv70WsI5kC9Md0ygD9/z1w7vNq8ptIW3Gm4dpWCdy35+V/bm1pXvFHbZmgsnkTvi5TtN51aT8R/oFU1u6/OiPrrCh4h8VayGEJmdFogAAAABJRU5ErkJggg=="/>
          </div>

          <div class="step-item">
            <img style="padding-left: 55px;" src="data:image/png;base64,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"/>
            <p class="step-item-title">转换并保存</p>
            <p class="step-item-text">将源OFD文件转为指定格式，并保存到指定位置</p>
          </div>
        </div>
      </div>

      <!-- 软件优势介绍 -->
      <div id="our-introduction">
        <div class="title">
          为什么选择我们
        </div>
        <!-- 介绍公司优势的一堆卡片 -->
        <div class="box-card">
          <el-card v-for="{title, text, headerBgColor, imgUrl} in OurReasons">
            <template #header>
              <div class="header" :style="`background-color: ${headerBgColor};`">
                <img :src="imgUrl"/>
              </div>
            </template>
            <template #default>
              <div class="default">
                <div class="default-title">{{title}}</div>
                <div class="default-text">{{text}}</div>
              </div>
            </template>
          </el-card>
        </div>
      </div>

      <!-- 用户评论 -->
      <div id="user-quotes">
        <div class="title">
          用户评价
        </div>
        <swiper-container ref="horizontalSwiperEl" class="swiper-container" init="false"
          v-show="!bVerticalSwiper"
        >
          <swiper-slide v-for="{userHeaderUrl, text} in UserQuotes">
            <div class="item-content">
              <img :src="userHeaderUrl">
              <p>{{text}}</p>
            </div>
          </swiper-slide>
        </swiper-container>

        <swiper-container ref="verticalSwiperEl" class="swiper-container" init="false"
          v-show="bVerticalSwiper"
        >
          <swiper-slide v-for="{userHeaderUrl, text} in UserQuotes">
            <div class="item-content">
              <img :src="userHeaderUrl">
              <p>{{text}}</p>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </div>
</template>

<style scoped>
.ofdconverter-view {
  max-width: 1920px;
  margin: 0 auto;
  background-color: #f5f8fb;
}

.soft-page-content-wrapper {
  margin-top: 59px;
}

#soft-introduction {
  text-align: center;

  display: flex;
  justify-content: center;

  #soft-name {
    color: #3c3c3c;
    font-size: 58px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%;
    letter-spacing: 2.32px;

    margin-top: 8vh;
    margin-bottom: 25px;
  }
  @media (max-width: 720px) {
    #soft-name {
      font-size: 48px;
    }
  }
  @media (max-width: 420px) {
    #soft-name {
      font-size: 32px;
    }
  }

  #soft-introduction-text {
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 34px;
    letter-spacing: 0.1em;
    color: #3A3A3A;
  }
  @media (max-width: 420px) {
    #soft-introduction-text {
      font-size: 20px;
      line-height: unset;
    }
  }

  #btn-soft-download {
    width: 318px;
    height: 106px;

    span {
      font-size: 35px;
      margin-left: 15px;
    }
  }

  #soft-supported-sys {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.115em;
    color: #737373;

    margin-top: 20px;
    margin-bottom: 20px;
  }
}


#soft-operation-steps {
  margin: 0 auto;
  padding: 5vh 0;

  background-color: white;

  .title {
    font-size: 36px;
    font-weight: 500;
    text-align: center;
    color: #010101;

    margin-bottom: 5vh;
  }
  @media (max-width: 1200px) {
    .title {
      font-size: 32px;
    }
  }

  .box-item {
    margin: 0 auto;
    max-width: 1200px;

    display: flex;
    justify-content: center;
    align-items: center;

    .step-item-connector {
      width: 147px;
      height: 147px;
      display: flex;
      align-items: start;
      justify-content: center;
    }

    .step-item {
      text-align: center;
      flex: 1;

      .step-item-title {
        margin-top: 20px;
        font-weight: 700;
        font-size: 20px;
      }
      .step-item-text {
        font-size: 16px;
        color: #666666;
      }
    }
  }
  @media (max-width: 1200px) {
    .box-item {
      flex-direction: column;
      .step-item-connector {
        img {
          transform: translateY(100%) rotate(90deg);
        }
      }

      .step-item {
        flex: 0;
      }
    }
  }
}


#our-introduction {
  /* background-image: url('https://yixingsoft.com/assets/productAdvantagesBgc.3b577885.png'); */
  padding: 5vh 0;
  .title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5vh;
  }

  .box-card{
    cursor: pointer;

    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;

    /* 在flebox中使用gap属性，需要chrome-84的支持 */
    /*   为了兼容性，改为在每一项内部设置margin，设置margin时大小要除以2 */
    /* gap: 20px; */

    justify-content: center;

    .el-card {
      margin: 10px 10px 10px 10px;

      flex-basis: 220px;
      border-radius: 24px;
    }

    :deep(.el-card__header) {
      padding: 0;
      .header {
        height: 192px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          /* width: 100px; */
          transition: scale 0.5s ease;
        }
        img:hover {
          scale: 1.1 1.1;
        }
      }
    }

    :deep(.el-card__body) {
      padding: 0;
      .default{
        height: 167px;
        .default-title {
          color: #333333;
          font-size: 24px;
          text-align: center;
          font-weight: bold;
          padding-top: 36px;
          padding-bottom: 36px;
        }
        .default-text {
          font-size: 14px;
          text-align: center;
          color: #666666;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  #our-introduction {
    padding: 5vh 5vh;
    .box-card{
      flex-direction: column;
      justify-content: center;

      align-items: center;
      .el-card {
        margin: 10px 0 10px 0;

        width: 100%;
        max-width: 450px;
        flex-basis: 359px;
      }
    }
  }
}

#user-quotes {
  padding: 5vh 0;

  background-color: white;
  .title {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
  }

  swiper-container {
    margin: 0 auto;
    height: 280px;
    width: 70%;
  }
  @media (max-width: 1680px) {
    swiper-container {
      width: 80vw;
    }
  }
  @media (max-width: 1480px) {
    swiper-container {
      width: 90vw;
    }
  }
  @media (max-width: 1280px) {
    swiper-container {
      width: 90vw;
    }
  }
  @media (max-width: 820px) {
    swiper-container {
      height: 680px;
    }
  }

  swiper-container::part(wrapper) {
    align-items: center;
    height: 100%;
  }

  swiper-slide {
    display: flex;
    align-items: center;
    opacity: 0.6;

    .item-content {
      width: 100%;
      height: clamp(160px, 160px, 160px);
      border-radius: 20px;
      box-shadow: 0px 0px 13px 1px #eff2ff;

      img {
        width: 59px;
        height: 59px;
        border-radius: 50%;
        padding: 4px;
        box-shadow: 0px 0px 4px 4px #eff2ff;

        position: relative;
        left: 0; top: 0;
        transform: translateX(50%) translateY(-50%);
      }
      p {
        position: relative;
        top: -20px;
        padding: 0 min(4%, 18px);
      }
    }
  }
  swiper-slide > * {
    pointer-events: none;
  }
  .swiper-slide-prev {
    padding-left: 10px;
  }

  .swiper-slide-active {
    transform: scale(1.05, 1.05);
    opacity: 1;
  }

  .swiper-slide-next {
    padding-right: 10px;
  }

  @media (max-width: 820px) {
    .swiper-slide-prev,
    .swiper-slide-active,
    .swiper-slide-next {
      padding: 0 20px;
    }
  }
}
</style>

<script lang="ts" setup>
/* definePageMeta()是编译器宏，不用实际代码运行 */
definePageMeta({
})

import * as Vue from 'vue'
import * as VueUse from '@vueuse/core'
import * as Util from '@/util'
import AppConfig from '@/AppConfig'

import {
  ElButton,
  ElCard
} from 'element-plus'

/* 导入Swiper element */
import * as SwiperElement from 'swiper/element/bundle'

SwiperElement.register()  /* 注册swiper库的自定义html标签 */

const szSoftName = '易趣OFD转换器'
const szSoftIconUrl = '/images/softs/ofdconverter/appLogo.png'

const szSoftPackageUrl = 'https://gitcode.com/qq_43479262/YQOFDConverter-package/releases/download/v1.0.1/YQOFDConverterMinIns_1.0.1.0_001.exe'

const OurReasons = Vue.ref([
  { title: '安全', text: '100%干净，安全，隐私保护',
    headerBgColor: '#cde1fc', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABF1BMVEUAAAAadvmJtvscdfone/mGtfyEtP0bdPoedfqItvuEs/uLt/t6rvsrffl7rvuLuPsbdPkpfPl9sPuMuPwbc/kkevkneviGtvyAsfgcdPkbdPmHtvsfdvuHtfqHtvyGtPwcdPn///8vgPlzqfskeflFjvpKkPp3q/tSlfp6rft/sPszg/koe/krfflvp/uGtftjoPpgnvogd/k2hPlcnPpBjPo+ivlOk/o7iPlmovtWmPqLuPtrpfsbdPl8r/uBsvuDs/uItvsedvltpvtamvo4hvlZmfpoo/v8/f/3+v/u9f7z+P6fxPzl7/681v3d6v7X5/6/2P2szP2RvPyYwPzq8v7N4P3F2/3T5P240/2myfy10v241Py0rUZzAAAAIXRSTlMAHyPz8aRubkv18/Lx2dfW1rmzsbGdb1Ago6Fzc3FXUlGMh+q7AAAC80lEQVRYw82T6VbaUBCABwXc97V7p5EGqGVpoRSlImIlSFgCCKh9/+fo3CwVdW6i5v7odzgnwyxfbiYn4DIT31pbOn4mS2tb8RmYZiZWO34psSnV+4VaCBY+gMubbEjegc1eNjR79n4WT0OzKPYUqyogBrCfVkF1H+JpJcRh80QJm7CaUsIqLKsRLYOuCHUiTRGga5rvzyWwTd2JMkFoZrfd1wPbgkTp6xYSzXE2SFT3YzAy0KNrZvxaoSJF67dRYIw7TTtoXZ/Iu6WirOVMX/a1SiVz4zonQ6mowVExu2jTG3op7ymvbursCJQZzJbzKJ30dFa/ddN9boYVNZ3lNh4VhhMUZDhRjoF6rXSOJfWHiimmIBOVczIuEXVOlGcgUS4vQ4iY9ItEGicqMJAoX5AhRExaJso9zOkjy5FfSUTnDAaJHqQ0OsjAjijIMDNwwdCkt3Y/IzzNjB22ECvMDBwxiF47qN7k7GtGeNJOURyXmWFFtAZdXOsGtsue58Sp0Ss1LjhRkqGHeCyuDbp7O5d0PG5Np++Wm2FFHcS+HQyQTGnhSXk1Sk2eLBoi9pzIRIHn8W7CikoMddpDwQlN26Pf1Wh/p9wMKxLdAzccGvc8KdImWdFnjj49mxdXLW2qQk9msSO8KG8g1rlCgQopiYhljDiSHLXLT0CCpUIr1h+ny3SgGj8BCR7aRbv0KDuh3SWeJxLf2/XDpIloNGSiooQsIg7vp2pOigeKMjo0NphOVGlBY2k7/JCR6JHJvPt/aog3Jm0nkYxkm0xWyflTNMX3m5R3w085pS4NX6ZFmBPH6yZ9mkkkJ2Eh0dPyHSSshF8v/PYl20KX5sC/E777Q1+pzfgooJFEAZzfGjgqB7bBl2CK509oIpEa4JMi/kNR9KsSorCiRrQCG4dK2IBdNaJdiBweKOAwArCjQrQDAJFoeE80AsT8wbewzIPN27CeOXD5OHsWgtl5+Efk1dmvF3L2OgLTROa212efK5ld357zNH8B+rTAoMPEZeQAAAAASUVORK5CYII=',
  },
  { title: '专业', text: '专业的支持服务，7*24支持',
    headerBgColor: '#fbeedf', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABC1BMVEUAAAD+tm7/tm7+ixn+t3H9ixj9kCL/tm3/tm7/tW3+jBr+t3H9jh79ihf/t23+sWX9kST+smb+uHL+ihj+kSL+jBf8ixn9jx//tm//ihb/r2j9jBn+tGz+tW3/tm/9kib+rl3+s2f+sWP9li/9lCr9kCL////+qVT9mTX9mzn9nT39ixn9n0D+r2D+tGr+p1H9jh7+tWz9mDL9jRz+rFn+pk7+t3D+pUv+pEn+okb9oUT+q1f+uHP/9Or//v3//fz+9+//+/f/+fP/7dz+5Mn+3bz+vXz/8eP/6dP+38H+06j//Pr+5s7+w4f+wIP+2rb+y5j+yZP+u3f+69f+17D+s2n+0aP+zp/+xY2jV1/rAAAAH3RSTlMA/iIe9PPxsqRuTP1wbVDx2dfW1rmxop1yIyD68/JXRXKGugAAAthJREFUWMPNktd22kAURYdiikvcaxqQ5FACyDiAQIAkegfTbP//l2QuwSskGsHCmgfvlzlzR2yOClvhDvrPvOUd8Z75g262jjtwkH8jB4E11Rdv3gHeD2zFjcshN2zJB1fGIa5lJ/enjGM+03MKpCUQYOxukZbBHQuGpRBkfjkiPzuVIzplxxEpHLOIJOSJUpKQJwpJ4h2KspKwE7k6BgTUeraikpgZbJiUxNiIRoBRsVID2naiqJAOMBeMFwbwEhUiFrWAfkR00ATqu4gGwFh4kNGBllikCCjrMCKKkC4wEB4IRQ2gqYjJ69DzQlHOiotfHM7Z0AC6orlI1F1eGx2l/j/IjJRcGeJ/YaqFMC+UVtUGauF/D4YGnlWVXoRqRSBqAg2+dIBKaH0+7QM9VaVPIyQQFSxUgTJfQiZQV/6OwzWgQ/s6MClYEIi4YExrukrVXqfZCtAmT56PhwJR0cIzgB6FlgHMV0OF96iUeIiYvFjB+isustAE8EhhAmCyHBUGgBnhgYrVlaJApFkpNgB9SKkHGC0K3F3N81VpUzFNABMNC511wULTnvh+SgczwExpQlFSRK4O9A940LjSzL4AGPEdVa2mk0KYeEy3UAuvQsUAJjRtUrHkDiJOyQTMEA9ZE5wezXr06JJ2ooQNqRqvEuUhzMOYJo/0MhN22IhIUAXqKg+50ZT2Qx2YJ3YVEeU+MNNed1MD6CbsYXF7WrxDI/knL7h1wLMtXGQP3U13mUI1oK7F3yQi6PnO+aqYQFuNbxTFNtID8BQrtgEzGtsIF21kTO98BlRTMQciogvCcMW2iR62EB8A0FsP2+CiLSSaujl62C76Jol3KPouiXco+ioJeSKfHI+PncgRnbCLH1K4YIdyRIfMI0fkYez6XgLXjDGPz7nH52Gc/ftfDrnfZ0sOnYqO2Ir9vZ8O2KM+KzxXb9Z8vPKwdW6PLs/3du5yfnl0uxL8Bg3mVUDOvVJWAAAAAElFTkSuQmCC',
  },
  { title: '保证', text: '提供试用，以卓越的信誉保证',
    headerBgColor: '#dedafd', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA5FBMVEUAAABsS/9oRv+ahP+ag/+Zg/+Zgf9rSP9pR/+Zg/+UfP9xUP+Ufv+chf9qR/9wUP+Wff+chv9pSP9qSP9tTP+ag/9vTf+TgP9tSf+YhP+Sev9xUf+XgP92V/+Pdv+Mcv97Xf+HbP+Vff90VP9vTv+Jb/9tS/+Faf+BZf9+YP+bhf95Wv9qSP+ag/9/Yv+DZv////+OdP/w7f+yof/PxP/Bs/+ijf/6+f/39f/l4P+nlP/u6v/SyP/Dtv+1pf/z8f/g2f/b0/+eiP/Xzv+ql//q5v/Huv+8rf+tm/+4p//Uyv/Kvv/BFW1PAAAAGnRSTlMA8h/zIqRuTG5Q8dnX1ta5s7Gxop1ybyBzV2+BVMAAAALBSURBVFjD3dEJU9pAGMbx5bbet22KENNaEAs8JCE3IQeX9vt/n4YkLWh3oyE7nU7/ju67L/E3GSVp1frZUaWXs8rRWb1KtqvWejtX26I+VXoFqnwgaVf9gl0lzod+4eJ3qlaahaus/061JodqhNw0uXRD6nygOjmVuHRKDvlAh2SfD7RPBE7911CLzxdp8elvQf2lP5/q+tRUFeEtaMSs5ZrYZDjBKCvSZmXNAZgTxQp62pNqAwj7bXZMaAHoam9z13zAUHJDoxBwmq9eUQaWeSEXcP9YCn6GRO6pSeGMsm07QLSnFkE5aoeYCjtD2785suEwoDtmTcudqN5cB2TveeJa/fXSAqKTEhtysBacSFDGqmdHXrhee1BzQrIqvbgLE6yPGfR2TmjyaqEgPgysqFCHlTxOh+f75FQQHw5+0B5/BwTpBeTC2xUSXkAabCo0ZCWP0wFCciqIjyYM2uNvQKosy4i+/Q0kMaAuK3kc/RA0TcNK04RoVhDve5Bpj2dCSWglZwrNYOaEFnRoApUKDViNMe7Gg9mJD80IkyueaI+TATMX/t3mtoQ6XJ8tQKJCD+yCqS2lY8eBm0wTmNSHqdDsKTnbpm6lwzRIVvcGVu+HdMySoatiPFi/2ryVfhTCHtAhkdICRjsdFfgdBeEwva4ATaRGhbo25p107k2BpZim6ViIOSBRMGDepfPQEsTN+/gPuSCxb0AOXu2ifxi8gciCHumNbMCRthaiNY82D4+sCOuDrgrAc0eJEkwieDqLRjbELPARZcw9c4oofTF8zIJuMxqNbSTpvtK9zSyCMhtIgTXT2sklGyoYf+gLp/5B6DOnSImPUyIHfKADcsIHOiHXX7l0Tcp8oDIhlzycS0JIufStcKUyiWoUhxok7mNRZ4+kNUrfC1RqkN+VL3Z3Lspku/Le+XEp97scn+/9Yn4CEWnP2xVLTQsAAAAASUVORK5CYII=',
  },
  { title: '可靠', text: '拥有超过10年经验团队打造出品',
    headerBgColor: '#ebd5fd', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAA9lBMVEUAAADXl//Ymf+yO//Ym/+xOP+1Qv/Yl/+yO/+yOP/Zl//Xlv/Tjf+2Rf/Tjv/ZnP+yN/+2RP/UkP/anf+xN/+yOP+yO/+vM//Tkv+0Qv+zQP/ZmP+6Tf+4SP+2Q/+0Pv+yOf/Rh//CYP/Jc//Zm//PhP/Nff/Si//Tjv/Vkf+7Uf/Wlf/XmP/GbP/EZv/DZP/////Hb//Faf/Ogf++WP/Lef+9Vf/Kdv/Vkv+8U/+/W//AXf+/XP/58P/aoP/+/P/15f/8+P/w2f/ry//px//jtv/36//y3v/v1v/lvf/kuf/is//grv/eqv/cpf/t0f/szf/nwv/AtTHVAAAAHHRSTlMAbyMe9PPxpKBvUPPx2dfW1rmzsbFPSiMgcG9Xd9hVOwAAAoxJREFUWMPNzudy2kAUhuFDMSXu3Sm2Q4dQ9IEhdmyr0STRuf+byaKBhJndFba1P/wws7BHh3dEa9HI+XE8/07x4/NIlLZFk/kPS26lvsfzIcS/0FqkFlKEfF9qofnvFN2vhrYfZaFkVYEk0c2TEjcUqSgRoTM1oTM6KitxRAdqQgdUUkRdKKPIJwwVFFEXelBEHqp4XR3QHe+JXarLrm7rw/m4JA0VxSquiQ136mDD7GeKQpLQxAb03sQwpn0dK8P+ZDYduKux8Y7QEtAnm8tsCGvz54Jnw5wKQx2BMdB9+H8tVreelS2YRocnCpVNuP6PQqbDK1rQC4LQI8+BXmRfNQfmk+BxxkafnwpCFcBgXxMAduZRYAz7gQ/lOB50dpZMWLXHnEjRxpQbCkIO+uxcYNjJSbhYvCVkY8JOHeOczAgWH2pyAIOdQ5SaMmMMuZkwNGNnp9CUGohCdY6FcT1YDy43I9GasyOkY8SHWpw8UGwFqQElbigINXXMgzp1CxY/pQbPAIyG3BIo81MSrbowa9KOB3iCMWkCTYuVNLERsGgI5iTczrGSIev0WIdHWaGmA8z4seaxjpYVoaxYqysoaT2uw4U4DUGJdZayfXqR0Vhpuj1YdUbSdXqV0ubAaOva868y9Cz30gcGm0u261+kqB3gdVVq+/xO0C61gzz777TuGIGr9DtQm5XmhXrZYp3gTRYKNoDPzO/Yoz+7ZLqAvejsWqNfu7Vbb1hiITXohyKfMnSr5EO3iqgLJdR0EnR4p8QhnaoJndJXNaFvFLu7uw/7YaEYUepegRQRxRLhO4kYMVfhQ1fkS/8MKU1rl3thMnuX9E8s9fFOKkbbrtMXJ3vvfpeTi/T1OvAXFxg0hKXgLRUAAAAASUVORK5CYII=',
  },
  { title: '海量用户', text: `超过百万用户选择了${AppConfig.WEBSITE_UI_NAME}`,
    headerBgColor: '#ceeefc', imgUrl: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAABO1BMVEUAAAAgsfiZ0/8itfib1f4es/kltfgitPia1f8gtPmX1P+X0/+R0v6U0/6Iz/0xuPkmtfgvt/iL0f6c1f4ds/iN0f6d1f+P0v+P0P+Q0f0htPiY0/////8wuPmGz/1+zf17zP08u/k5uvk1uflSwvuN0f6J0P0st/gotvhAvPmR0v4ltfiW1P54y/whtPhDvfqa1f5ryPxnx/xJv/oes/hbxPtyyvxixvtexftXw/uBzv2Dzv2T0/5lxvtvyvxGvvp1yvxNwPpMv/puyPxPwPqc1f75/f78/v/n9v6W2f255v2Q1/31+/7v+f7e8/625P3b8v6K1Px80Pzr+P7h9P7V8P7L7P6o3/12zvzD6f6/6P2d2v2G1Pzx+v7R7v7I6/2r4f2h3vzj9f7Y8f7X8P685/2w4v2j3v3O7f4BmTaZAAAAHHRSTlMAHyNu9PO1oHBMpFD98/Hx8NnX1tazsW4goXNXSIg5rgAAA15JREFUWMOszr0KgCAYheHDh4PYz1CURlBTDeHgXK3d/y0F4uBanucCXl4kosdePR+pftSCnJjwm8lSswoFVIVE+0IaUeWLxSdp7mKNADAHwQS4mhGqHexGYTFwQgO6naJDywm1WEh4oYsEJwlWEl7oZWXsVhQEoyjqgyyaeQEv6qIkSATh8/8vTS1HmYtoev8nGD7NGJgT3rRuzmYf9vp8E+8TmQvss0qRDD/mAkuiJmaiKhZEzivM1cp0bjzpC+cjCFbOC4ytTJB7EGtP2jnbVaig7DzAb+TBC9GZmXoqIgWKkZMpimyJC9DnuQ/l9lHdQN3zXAGDNDFcgQLIbNc9QzZ3joJP191egE7YGGuBGkJ9cwiepQ/R43kVNqKoh1bf4a+ohELfL1CSaCMA/XgvkM2dAzg6rIH2/0YUKXD1jSC2H10I1RiOgLAxDgIpfOu78SFfj1UHdGPSRmFj7AQaiCMdAg+S5thGdyB1ddV50AgbUXTwgVMWlp7PE3+gysJUp4MksiTahIlrMKd6HTORtNJEFll2jSaOrF1398s03FtWoyajbYmiX9bHZqVhIAqjeZCzEbJxJVqGpEIjFcmY/qQmbdSWaNrE2vd/A+8VEWYccePZnAsfc0LML9Td0OwnciR1W7WZES5nm2FbmzDh0OW+R7DV5DBYlOXu2qwQ7HBIg6HxT4z+BEovxzfNPYJG54FHgVDSICyabYmSP2x3j1+NrnvL1cdAKPYxG6BsTVwtgKYysXJ1WgJvaWwKjXbj2ONnqAN7EtcWllX8TbrSrgTGR+Dpz9AcmIuTF+gTd7Kw0mMPNvNDdy7xPbzrsYV14o0FUOvxCp23RVOXFl7G4gyoxS5SH9QTC4k7RbcuM9irj3BUu6Q5ZHo8QuFO0cilhGfRdAGZ2Ee/oy5g5y5+KAcjeoZ+FKCGjUj3Vy9045KTqwqYqX2mYEfiBEp3iS5cDsvDp0AcYA2perVu3UFCIU4wDw4lmOAQnQeZ9A9xcGgXu/ALCf0P0dk/8dHKHKMACANBANzjSMJVJpBKsNFCQUjl/9+miIqt3s4DhheNJLxoIuFFAwk6ztOhcKKCOFNEKCdSyEIhQGI8CYDk1S0LDuaPDKe+OSkuFjxNMDwkbX+1JHgTjTV8TUKNejc7m52JysEtyLQAAAAASUVORK5CYII=',
  },
])


const UserQuotes = Vue.ref([
  {
    userHeaderUrl: '/images/softs/ofdconverter/head1.png',
    text: '工作中会收到部分OFD格式的档案，就会用这个软件转成PDF，方便更好阅读',
  },
  {
    userHeaderUrl: '/images/softs/ofdconverter/head2.png',
    text: '电子发票基本都是OFD格式，不好打开查看，就会用OFD转换器去转换然后发给他人',
  },
  {
    userHeaderUrl: '/images/softs/ofdconverter/head3.png',
    text: '经常用这款软件输出长图，提取重要信息发给客户浏览，很方便实用',
  },
  {
    userHeaderUrl: '/images/softs/ofdconverter/head4.png',
    text: '做财务会收到大量OFD发票，一次批量转成图片，就很节省工作时间',
  },
])

const horizontalSwiperEl = Vue.ref<any>({})
const verticalSwiperEl = Vue.ref<any>({})

/* 屏幕 >= 820px时，将轮播图改为垂直方向 */
const bVerticalSwiper = VueUse.useMediaQuery('(max-width: 820px)')

/* 用于动态设置当前页面的标题 */
useHead({
  title: szSoftName + '-支持OFD转PDF_OFD转Word',
  link: [
    { rel: 'icon', href: szSoftIconUrl }
  ],
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    { name: 'description', content: szSoftName + '是一款支持批量OFD文件转换格式的工具，并且能提供其他格式转OFD、OFD转其他格式的功能' },
    { name: 'keywords', content: szSoftName + ',OFD转换工具,OFD转换' },
  ],
})

Vue.onMounted(() => {
  /* 动态设置当前页面的图标，参考：https://stackoverflow.com/questions/77135452/how-to-change-the-favicon-dynamically-in-nuxt-3 */
  /* 对于Nuxt项目，可以使用useHead()，但是好像对于图标来说，只能支持svg? */
  /*   这里使用VueUse.useFavicon设置png */
  VueUse.useFavicon(szSoftIconUrl, {
    rel: 'icon'
  })

  const swiperParam = {
    grabCursor: false,
    centeredSlides: true,  /* 让当前active的项位于中间 */
    slidesPerView: '3',  /* 同时展示3条内容 */
    spaceBetween: '40',
    eventsPrefix: 'swiper-',  /* 指定swiper内部事件的前缀，使用SwiperElement版本时需要 */
    loop: true,
    /* 自动切换内容 */
    autoplay: {
      delay: 3000,  /* 每次切换的间隔，单位ms */
      stopOnLastSlide: false,  /* 当切换到最后一项时，是否停止切换 */
    },
  }

  if(horizontalSwiperEl.value)
  {
    Object.assign(horizontalSwiperEl.value, {
      direction: 'horizontal',
      ...swiperParam,
    })
    horizontalSwiperEl.value.initialize()
  }

  /* 用于移动端上展示的轮播图 */
  if(verticalSwiperEl.value)
  {
    Object.assign(verticalSwiperEl.value, {
      direction: 'vertical',
      allowTouchMove: false,  /* 禁止通过滑动的方式切换轮播图 */
      /* 移动端上swiper通常占据大部分屏幕，默认情况下，在swiper内容上用手滚动时，无法触发移动端的页面滚动行为 */
      /*   设置touchReleaseOnEdges为true，在swiper内容上用手滚动时，支持触发页面自身的滚动效果 */
      touchReleaseOnEdges: true,
      threshold: 0,  /* 需要滑动多远距离才能触发滚动，touchReleaseOnEdges为true时，必须为0 */
      ...swiperParam,
    })
    verticalSwiperEl.value.initialize()
  }
})
</script>
